import styled, { css } from 'styled-components';
import * as variables from 'styles/variables';
import { rotateAnimation } from 'components/Styled/Loader';

export const CloseIcon = styled.div`
	position: absolute;
	top: 10px;
	right: 10px;
	color: white;
`;

export const Content = styled.div`
    position: relative;
    margin: 0 10px;
    width: 38px;
    height: 38px;
`;

export const IconBorder = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:after {
		box-sizing: border-box;
		position: absolute;
        content: ' ';
        width: 38px;
        height: 38px;
		border-radius: 50%;
		border: 2px solid ${({ $isUnread }) => $isUnread ? variables.primaryColors.primary : variables.primaryColors.secondary};
		
		${({ $isLoading }) => $isLoading && css`
			border-bottom: 2px solid ${variables.primaryColors.primary};
			animation: ${rotateAnimation} 1.5s linear infinite;
		`}
    }
    
    svg {
        transform: translateY(1px);
        stroke: ${variables.primaryColors.text};
        fill: ${variables.primaryColors.text};
        transition: opacity 0.2s ease;
        opacity: 0.7;
		width: 28px;
		height: 28px;
    }

    &:hover {
        svg {
            opacity: 1;
        }
    }
`;
